import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { Resolver } from '@app/services/resolver';
import { API } from '../classes/api';

export const GroupGuard:CanActivateFn = (route,state) => {
    const resolver = inject(Resolver);
    const group_key_em = route.paramMap.get('group_id');
    const redirect = new RedirectCommand(inject(Router).parseUrl('/'));
    if(group_key_em === null) return redirect;
    return API.group.get({group_key_em})
    .then($_ => {
        resolver.group.set($_)
        return true;
    })
    .catch(error => {
        resolver.group.set(undefined)
        return redirect;
    })
}
